// src/utils/dateUtils.ts
export interface Month {
    label: string;      // e.g., "Jan 2025"
    startDate: Date;    // First day of the month
    endDate: Date;      // Last day of the month
}

export const getNext12Months = (): Month[] => {
    const months: Month[] = [];
    const today = new Date();
    today.setDate(1); // Set to first day of current month for consistency

    for (let i = 0; i < 12; i++) {
        const current = new Date(today.getFullYear(), today.getMonth() + i, 1);
        const next = new Date(current.getFullYear(), current.getMonth() + 1, 1);
        const endDate = new Date(next.getTime() - 1); // Last moment of current month

        const label = current.toLocaleString('default', { month: 'short' });

        months.push({
            label,
            startDate: current,
            endDate: endDate
        });
    }

    return months;
};
